import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "kn-page-content"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_LovsManagementDetailCard = _resolveComponent("LovsManagementDetailCard")
  const _component_LovsManagementWizardCard = _resolveComponent("LovsManagementWizardCard")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-m-0" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.selectedLov.label), 1)
      ]),
      end: _withCtx(() => [
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.saveButtonDisabled,
          onClick: _ctx.saveLov,
          "data-test": "submit-button"
        }, null, 8, ["disabled", "onClick"]), [
          [_directive_tooltip, _ctx.$t('common.save')]
        ]),
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.closeTemplate,
          "data-test": "close-button"
        }, null, 8, ["onClick"]), [
          [_directive_tooltip, _ctx.$t('common.close')]
        ])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_LovsManagementDetailCard, {
              selectedLov: _ctx.selectedLov,
              lovs: _ctx.lovs,
              listOfInputTypes: _ctx.listOfInputTypes,
              onTouched: _ctx.setTouched,
              onTypeChanged: _ctx.cleanSelections
            }, null, 8, ["selectedLov", "lovs", "listOfInputTypes", "onTouched", "onTypeChanged"])
          ]),
          _createVNode("div", _hoisted_3, [
            (_ctx.selectedLov.itypeCd)
              ? (_openBlock(), _createBlock(_component_LovsManagementWizardCard, {
                  key: 0,
                  selectedLov: _ctx.selectedLov,
                  selectedQuery: _ctx.selectedQuery,
                  selectedScript: _ctx.selectedScript,
                  datasources: _ctx.datasources,
                  profileAttributes: _ctx.profileAttributes,
                  listOfScriptTypes: _ctx.listOfScriptTypes,
                  listForFixLov: _ctx.listForFixLov,
                  selectedJavaClass: _ctx.selectedJavaClass,
                  selectedDataset: _ctx.selectedDataset,
                  save: _ctx.save,
                  previewDisabled: _ctx.saveButtonDisabled,
                  onTouched: _ctx.setTouched,
                  onCreated: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCreated())),
                  onSelectedDataset: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSelectedDataset($event))),
                  onSorted: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSort($event)))
                }, null, 8, ["selectedLov", "selectedQuery", "selectedScript", "datasources", "profileAttributes", "listOfScriptTypes", "listForFixLov", "selectedJavaClass", "selectedDataset", "save", "previewDisabled", "onTouched"]))
              : _createCommentVNode("", true)
          ])
        ]))
  ], 64))
}